import React, { ComponentProps } from 'react'

import {
  Dialog as UIFoundationDialog,
  DialogMaxWidthSizes,
  Text as UIFoundationText,
  TextVariants,
  Container as UIFoundationContainer,
  ContainerProps,
  ContainerDisplays,
  ContainerFlexDirections,
  InputTextFieldProps,
  ButtonProps,
  ButtonWidths,
  InputTextField as UIFoundationInputTextField,
  Button as UIFoundationButton,
  ContainerFlexGaps,
  ContainerFlexAlignItems
} from '@dcxwam/dcx-wam-ui-foundations'
import { SubmitCodeProps } from './types'

function SubmitRewardsCode(props: Readonly<SubmitCodeProps>) {
  const {
    open,
    inputValue,
    isLoading = false,
    enterCodeLabel,
    enterCodePlaceholder,
    enterCodeHelper,
    enterCodeTooltipMessage,
    submitCodeButtonLabel,
    enterCodesModalTitle,
    onChange,
    onClose,
    onSubmit
  } = props

  const titleConfig: ComponentProps<typeof UIFoundationText> = {
    variant: TextVariants.H5,
    content: enterCodesModalTitle
  }

  const containerConfig: ContainerProps = {
    display: ContainerDisplays.Flex,
    flexDirection: ContainerFlexDirections.Column,
    flexGap: ContainerFlexGaps.Size_3,
    className: 'submit-code-container'
  }

  const formContainerConfig: ContainerProps = {
    display: ContainerDisplays.Flex,
    flexDirection: ContainerFlexDirections.Column,
    flexAlignItems: ContainerFlexAlignItems.Start,
    flexGap: ContainerFlexGaps.Size_5
  }

  const inputTextProps: InputTextFieldProps = {
    label: enterCodeLabel,
    tooltipMessage: enterCodeTooltipMessage,
    placeholder: enterCodePlaceholder,
    helperText: enterCodeHelper,
    defaultPadding: false,
    value: inputValue,
    onChange,
    tooltipIsHtml: true,
    tooltipProps: {
      className: 'enter-codes-tooltip'
    }
  }

  const submitButtonConfig: ButtonProps = {
    label: submitCodeButtonLabel,
    buttonWidth: ButtonWidths.Auto,
    disable: !inputValue || isLoading,
    onClick: () => {
      if (!inputValue || isLoading) {
        return
      }

      onSubmit?.(inputValue)
    }
  }

  return (
    <UIFoundationDialog
      isOpen={open}
      onClose={() => {
        onClose?.()
      }}
      dismissible
      closeAriaLabel="Close"
      className="submit-code-modal"
      maxWidth={DialogMaxWidthSizes.MD}
      fullWidth
      zIndex={2001}
      transparentBackdrop
    >
      <UIFoundationContainer {...containerConfig}>
        <UIFoundationText {...titleConfig} />
        <UIFoundationContainer {...formContainerConfig}>
          <UIFoundationInputTextField {...inputTextProps} />
          <UIFoundationButton {...submitButtonConfig} />
        </UIFoundationContainer>
      </UIFoundationContainer>
    </UIFoundationDialog>
  )
}

export { SubmitRewardsCode }
